import { Lead } from "shared/topchef.types";

export interface AvailableSlotsRendererProps {
  lead: Lead;
  maxSlots?: number;
}

const AvailableSlotsRenderer = ({ lead, maxSlots = 4 }: AvailableSlotsRendererProps) => {
  const followersCount = lead.followers?.length || 0;

  return (
    <div className="d-flex gap-2">
      {Array.from({ length: Math.min(maxSlots, followersCount) }).map((_, i) => (
        <div
          key={i}
          className="host_slot border border-secondary rounded-circle ratio ratio-1x1 w-25 bg-secondary"
          title={`${lead.followers[i].place.name} - ${new Date(lead.followers[i].creationDate).toLocaleDateString()}`}
        />
      ))}
      {Array.from({ length: maxSlots - followersCount }).map((_, i) => (
        <div
          key={i}
          className="host_slot border border-secondary rounded-circle ratio ratio-1x1 w-25 empty-slot"
        />
      ))}
    </div>
  );
};

export default AvailableSlotsRenderer;